import * as types from 'constants/actionTypes';

import Axios from 'axios';
const SET_ROLEDATA = 'SET_ROLEDATA';
const SET_AUTHORITYDATA = 'SET_AUTHORITYDATA';

export function getRole() {
  return dispatch => {
    dispatch(setRoleData('', 1, ''));
    Axios.get(`https://api-v2.ajarlabs.online/group/`)
      .then(response => {
        let data = response.data.content;
        let responsestatus = 0;
        let pages = response.data.total_pages;
        dispatch(setRoleData(data, responsestatus, pages));
      })
      .catch(error => {
        console.log('error get role');
      });
  };
}

export function getAuthority() {
  return dispatch => {
    dispatch(setAuthorityData('', 1, ''));
    Axios.get(`https://api-v2.ajarlabs.online/authority/`)
      .then(response => {
        let data = response.data.content;
        let responsestatus = 0;
        let pages = response.data.total_pages;
        dispatch(setAuthorityData(data, responsestatus, pages));
      })
      .catch(error => {
        console.log('error get authority');
      });
  };
}

export function saveAuthority(nama) {
  const querystring = { name: nama };
  Axios.post(`https://api-v2.ajarlabs.online/authority`, querystring)
    .then(response => {
      if (response.status === 200) {
        alert('Data Berhasil Di Simpan');
        getAuthority();
      } else {
        alert('Data Gagal Di Simpan');
      }
    })
    .catch(error => {
      console.log('Error Connecting');
    });
}

export function deleteAuthority(id) {
  Axios.delete(`https://api-v2.ajarlabs.online/authority/${id}`)
    .then(response => {
      if (response.status === 200) {
        alert('Data Berhasil Di Hapus');
      } else {
        alert('Data Gagal Di Hapus');
      }
    })
    .catch(error => {
      console.log('Error Connecting');
    });
}

function setRoleData(data, response, pages) {
  return {
    type: SET_ROLEDATA,
    data,
    response,
    pages,
  };
}

function setAuthorityData(data, response, pages) {
  return {
    type: SET_AUTHORITYDATA,
    data,
    response,
    pages,
  };
}

const roledata = (
  state = {
    data: [],
    response: 1,
    pages: '',
  },
  action
) => {
  switch (action.type) {
    case SET_ROLEDATA:
      return Object.assign({}, state, {
        data: action.data,
        response: action.response,
        pages: action.pages,
      });
    default:
      return state;
  }
};

const authoritydata = (
  state = {
    data: [],
    response: 1,
    pages: '',
  },
  action
) => {
  switch (action.type) {
    case SET_AUTHORITYDATA:
      return Object.assign({}, state, {
        data: action.data,
        response: action.response,
        pages: action.pages,
      });
    default:
      return state;
  }
};

export { roledata, authoritydata };
